import { useEffect, useRef, useState } from 'react';
import { Calendar16 } from 'ui/icons/aurora/16px/Calendar16';
import { displayDate, setDate } from 'utils/date';
import { noop } from 'utils/noop';
import { DATE_PLACEHOLDER, NULL_DATE_PLACEHOLDER, selectInputText } from '../helpers';
import { InputWrapper, StyledDateInput } from './DatePickerInput.styles';

const isValidDate = (strDate) => {
  const date = new Date(strDate);
  return date instanceof Date && !isNaN(date) && date.getFullYear() < 9999;
};

// type DateInputProps = {
//   /** Unique id of input */
//   id: string,
//   /** Whether input is read only */
//   isReadOnly?: boolean,
//   isInvalidRange?: boolean,
//   /** Applies disabled styles for a disabled input */
//   isDisabled?: boolean,
//   /** Date to display */
//   date: moment,
//   /** Function to be run when the date is updated */
//   onDateChange?: (moment) => void,
//   /** Function run when entry is changed (for internal use) */
//   onEntryChange?: () => void,
//   /** Custom/override placeholder text */
//   placeholder?: string,
// };
/**
 * DateInput
 * @param {any} date
 * @param {string} id
 * @param {boolean=} isReadOnly
 * @param {boolean=} isDisabled
 * @param {boolean=} isInvalidRange
 * @param {() => void=} onDateChange
 * @param {() => void=} onEntryChange
 * @param {string=} placeholder
 */
export const DateInput = ({
  date,
  id,
  isReadOnly = false,
  onDateChange = noop,
  onEntryChange = noop,
  placeholder = NULL_DATE_PLACEHOLDER,
  isDisabled,
  isInvalidRange,
}) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState(displayDate(date));
  const [isValid, setIsValid] = useState(true);
  const [isFocused, setIsFocused] = useState(false);

  const validateDate = () => {
    const isDateNull = date === null;
    const formattedDate = displayDate(value);
    const checkIsValid =
      (formattedDate !== 'Invalid date' && isValidDate(formattedDate)) || isDateNull;
    if (checkIsValid) {
      setValue(formattedDate);
      onDateChange(isDateNull ? date : setDate(date, formattedDate));
    }
    setIsValid(checkIsValid);
    setIsFocused(false);
    onEntryChange({ [id]: checkIsValid });
  };

  const handleFocus = () => {
    selectInputText(inputRef);
    setIsFocused(true);
  };

  useEffect(() => setValue(displayDate(date)), [date]);

  const renderValue = () => {
    if (date) {
      return value;
    } else if (date === null) {
      return placeholder;
    }
    return DATE_PLACEHOLDER;
  };

  return (
    <InputWrapper
      isValid={isValid && !isInvalidRange}
      isFocused={isFocused}
      isDisabled={isDisabled}
    >
      <Calendar16 />
      <StyledDateInput
        id={id}
        value={renderValue()}
        type="text"
        onChange={(e) => setValue(e.target.value)}
        onBlur={validateDate}
        onFocus={handleFocus}
        readOnly={isReadOnly}
        ref={inputRef}
        placeholder={DATE_PLACEHOLDER}
        data-test={`${id}${isValid ? '' : '-invalid'}`}
        tabIndex={0}
      />
    </InputWrapper>
  );
};
